import React, { useEffect, useState } from "react";
import ContentBox from "../ContentBox/ContentBox";
import { Button, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import ButtonLoading from "../Button/ButtonLoading";
import ApiClient from "../../services/ApiClient";
import { ReleaseUpdate } from "../../types/ReleaseUpdate";
import _ from "lodash";
import { Roles } from "../../types/BackofficeUser";
import releaseUpdateStyles from "./releaseUpdatesStyles";
import { Link, useNavigate } from "react-router-dom";
import LegalbirdTipTapEditor from "../LbEditor/LegalbirdTipTapEditor";
import LegalbirdTipTapEditorProvider from "../LbEditor/LegalbirdTipTapEditorProvider";
import { useCurrentEditor } from "@tiptap/react";
import { getEditorHtml } from "../../services/Editor/editorFunctions";

type EditReleaseUpdateProps = {
  releaseUpdate: ReleaseUpdate;
};

export default function EditReleaseUpdate(props: EditReleaseUpdateProps) {
  return (
    <LegalbirdTipTapEditorProvider>
      <EditReleaseUpdateInner {...props} />
    </LegalbirdTipTapEditorProvider>
  );
}

function EditReleaseUpdateInner({ releaseUpdate }: EditReleaseUpdateProps) {
  const navigate = useNavigate();
  const { editor } = useCurrentEditor();
  //only check role accountmanager because its always there for internal release updates
  const isInternalReleaseUpdate = _.includes(releaseUpdate.visibleToRoles, Roles.accountmanager);
  const isExternalReleaseUpdate = _.includes(releaseUpdate.visibleToRoles, Roles.external);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    editor?.commands.setContent(releaseUpdate.content);
  }, []);

  if (!editor) {
    return null;
  }

  const releaseUpdatesPageLink = "/services/tools/release-updates";

  const handleSaveChanges = async () => {
    setIsLoading(true);
    await ApiClient.patch(releaseUpdate["@id"], {
      body: JSON.stringify({
        content: getEditorHtml(editor),
      }),
    });
    setIsLoading(false);
    navigate(releaseUpdatesPageLink);
  };

  return (
    <ContentBox>
      <Grid
        container
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "center"
        }}>
        <Grid size={12}>
          <LegalbirdTipTapEditor />
        </Grid>
        <Grid size={12}>
          <Typography variant={"h4"} sx={{ textAlign: "center" }}>
            Sichtbarkeit
          </Typography>
        </Grid>
        <Grid>
          <FormControlLabel
            labelPlacement="start"
            control={<Checkbox checked={isInternalReleaseUpdate} disabled />}
            label={"Intern"}
          />
        </Grid>
        <Grid>
          <FormControlLabel
            labelPlacement="start"
            control={<Checkbox checked={isExternalReleaseUpdate} disabled />}
            label={"Extern"}
          />
        </Grid>
        <Grid size={12} />
        <Grid>
          <Button fullWidth={false} sx={releaseUpdateStyles.button} component={Link} to={releaseUpdatesPageLink}>
            Abbrechen
          </Button>
        </Grid>
        <Grid>
          <ButtonLoading
            isLoading={isLoading}
            fullWidth={false}
            variant={"contained"}
            disabled={(!isExternalReleaseUpdate && !isInternalReleaseUpdate) || editor.isEmpty}
            onClick={handleSaveChanges}
            sx={releaseUpdateStyles.button}
          >
            Änderung speichern
          </ButtonLoading>
        </Grid>
      </Grid>
    </ContentBox>
  );
}
